import { useEffect } from 'react';
import DescriptionBanner from '../Components/DescriptionBanner';
import CircularProgressCard from '../Components/CircularProgressCard';
import ModalWrapper from '../Components/UI/ModalWrapper';
import { useState } from 'react';
import useGet from '../Hooks/useGet';
import { API_ENDPOINTS } from '../Config/api';
import { Navigate, useNavigate, useOutletContext } from 'react-router-dom';
import OrderDetailsTable from '../Components/Table/OrderDetailsTable';
import FileAngelTable from '../Components/Table/FileAngelTable';
import BrowsingAngelTable from '../Components/Table/BrowsingAngelTable';
import Nis2Risk from '../Components/Nis2Risk';
import Alert from '../Components/Modal/Alert';
import CyberSurveillanceDashboard from '../Components/CyberSurveillanceDashboard2'
import { useTranslation } from 'react-i18next';
import { fetchWithAuth } from '../Utils/fetchWithAuth';
import { useRecoilValue } from 'recoil';
import { disableForEnterpriseAtom } from '../Atom/disableForEnterpriseAtom';


export default function Dashboard() {

    const { t } = useTranslation();
    const disableForEnterprise = useRecoilValue(disableForEnterpriseAtom)
    const { isVisible } = useOutletContext() || {};

    
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [childrenModal, setChildrenModal] = useState(null)
    const [modalMaxWidth, setModalMaxWidth] = useState('')
    const navigate = useNavigate();

    const { fetchedData: browsingAngelData, loading: loadbrowsingAngelData } = useGet(API_ENDPOINTS.aziendaBrowsingAngelStats);
    const { fetchedData: fileAngelData, loading: loadfileAngelData } = useGet(API_ENDPOINTS.aziendaFileAngelStats);
    const { fetchedData: totEndpointData, loading: loadtotEndpointData } = useGet(API_ENDPOINTS.aziendaDashboard);
    const { fetchedData: currentQuestionario } = useGet(API_ENDPOINTS.questionarioCurrent);
    const { fetchedData: cyberSurveillanceData, loading: loadCyberSurveillance } = useGet(API_ENDPOINTS.cyberSurveillance);

    const [nis2Report, setNis2Report] = useState(null);

    useEffect(() => {
        if (currentQuestionario?.id) {
            fetchWithAuth(API_ENDPOINTS.nis2Report(currentQuestionario.id))
                .then((res) => {
                    if (res.ok) {
                        return res.json();
                    } else {
                        // If the response is not ok (e.g., 400 for incomplete questionnaire), set null
                        console.warn("NIS2 Report not available:", res.status);
                        return null;
                    }
                })
                .then(setNis2Report)
                .catch((err) => {
                    console.error("Errore nel fetch del nis2Report:", err);
                    setNis2Report(null);
                });
        }
    }, [currentQuestionario?.id]);


    function handleOpenModal(childrenModal, maxWidth = '') {
        setChildrenModal(childrenModal)
        setModalMaxWidth(maxWidth)
        setIsModalOpen(true)
    }

    function handleCloseModal() {
        setChildrenModal(null)
        setModalMaxWidth('')
        setIsModalOpen(false)
    }

    // Se l'account non è ancora visibile, redirect alla pagina ordini
    if (isVisible === false) {
        return <Navigate to="/ordini" replace />;
    }

    return (
        <div className='space-y-4 sm:space-y-6 p-2 sm:p-4 lg:p-6 pb-8 sm:pb-12 lg:pb-16'>

            <DescriptionBanner title='Dashboard' description={t('DescrBann_Dashboard')} />

            

            <div className='flex flex-col gap-6' data-tour="dashboard-cards">
                
                {/* Section with other cards */}
                <div className='flex flex-col gap-4 w-full'>

                    <div>
                        <h2 className="text-base sm:text-lg uppercase font-semibold text-gray-800 mb-2">
                            {t('TitleBann2_Dashboard')}
                        </h2>
                        <p className="text-sm sm:text-base text-gray-700 mb-2">
                            {t('DescrBann2_Dashboard')}
                        </p>
                    </div>

                    <div className="w-full flex flex-wrap justify-center sm:justify-start gap-3 sm:gap-4 md:gap-6 lg:gap-8">

                        {/* CARD 1: ORDINI / ENDPOINTS */}
                        <div className="flex justify-center" data-tour="dashboard-card-endpoints">
                            <CircularProgressCard
                                textSize='text-xl'
                                textColor='text-black'
                                fill={'#F3F4F7'}
                                size={180}
                                attivi={totEndpointData?.codici_attivazione?.totale_endpoint_utilizzati}
                                totale={totEndpointData?.codici_attivazione?.totale_endpoint_massimo}
                                text1={`${totEndpointData?.codici_attivazione?.totale_endpoint_utilizzati || 0} su ${totEndpointData?.codici_attivazione?.totale_endpoint_massimo || 0}`}
                                text2={t('dashboard.active')}
                                label={t('dashboard.totalEndpointsUsed')}
                                buttonLabel={t('ButtonLabelOrders')}
                                onClick={() => handleOpenModal(
                                    <OrderDetailsTable orderData={totEndpointData?.codici_attivazione?.ordini} />)
                                }
                                disabledDetails={disableForEnterprise ?? false}
                                loading={loadtotEndpointData}
                            />
                        </div>

                        {/* CARD 2: FILE ANGEL */}
                        <div className="flex justify-center" data-tour="dashboard-card-fileangel">
                            <CircularProgressCard
                                attivi={fileAngelData?.company_stats?.malware_files || 0}
                                totale={100}
                                text1={`${fileAngelData?.company_stats?.malware_rate_avg ?? 0}%`}
                                text2={'MALWARE'}
                                text3={'RATE'}
                                size={180}
                                buttonLabel={t('ButtonLabelDetails')}
                                label={'File angel'}
                                onClick={() => handleOpenModal(
                                    <div className='bg-[#F3F4F7] p-7 rounded-md border'>
                                        <FileAngelTable fileAngelStats={fileAngelData} isVisibleTotValue={false} />
                                    </div>
                                , '80vw')}
                                disabledDetails={disableForEnterprise ?? false}
                                loading={loadfileAngelData}
                            />
                        </div>

                        {/* CARD 3: BROWSING ANGEL */}
                        <div className="flex justify-center" data-tour="dashboard-card-browsingangel">
                            <CircularProgressCard
                                attivi={browsingAngelData?.company_stats?.protection_effectiveness || 0}
                                totale={100}
                                text1={`${browsingAngelData?.company_stats?.protection_effectiveness ?? 0}%`}
                                text2={t('dashboard.protection')}
                                text3={t('dashboard.average')}
                                size={180}
                                buttonLabel={t('ButtonLabelDetails')}
                                label={'Browsing Angel'}
                                onClick={() => handleOpenModal(
                                    <div className='bg-[#F3F4F7] p-7 rounded-md border'>
                                        <BrowsingAngelTable browsingAngelStats={browsingAngelData} isVisibleTotValue={false} />
                                    </div>
                                )}
                                disabledDetails={disableForEnterprise ?? false}
                                loading={loadbrowsingAngelData}
                            />
                        </div>

                        {/* CARD 4: CYBER SURVEILLANCE */}
                        <div className="flex justify-center" data-tour="dashboard-card-surveillance">
                            <CircularProgressCard
                                disabledDetails={!cyberSurveillanceData}
                                attivi={cyberSurveillanceData?.results?.meta?.summary?.total_vulnerabilities ? 5 : 0}
                                totale={5}
                                text1={`${cyberSurveillanceData?.results?.meta?.summary?.total_vulnerabilities || 0}`}
                                text2={t('dashboard.threats')}
                                text3={t('dashboard.detected')}
                                size={180}
                                buttonLabel={t('ButtonLabelDetails')}
                                label={'Cyber Surveillance'}
                                onClick={() => handleOpenModal(
                                    <div className='bg-[#F3F4F7] p-7 rounded-md border'>
                                        <CyberSurveillanceDashboard cyberSurveillanceResult={cyberSurveillanceData} viewDescriptionBanner={true} />
                                    </div>
                                )}
                                loading={loadCyberSurveillance}
                            />
                        </div>

                        {/* CARD 5: NIS2 RISK SCORE */}
                        <div className="flex justify-center" data-tour="dashboard-card-nis2">
                            <CircularProgressCard
                                attivi={nis2Report?.percentuale_conformita || 0}
                                totale={100}
                                text1={nis2Report?.percentuale_conformita ? (nis2Report.percentuale_conformita + '%') : '?'}
                                size={180}
                                buttonLabel={t('ButtonLabelDetails')}
                                label={'NIS2 Risk Score'}
                                onClick={() => handleOpenModal(
                                    currentQuestionario?.stato.toLowerCase() === 'completato' ?
                                        <div className='bg-[#F3F4F7] p-7 rounded-md border'>
                                            <Nis2Risk nis2ReportData={nis2Report} />
                                        </div>
                                        :
                                        <Alert type='warning' title={'Attenzione'} message={'Prima di procedere completa il questionario'} onClose={handleCloseModal} />
                                , '1000px')}
                            />
                        </div>
                    </div>
                </div>

            </div>

            <ModalWrapper position='center' isOpen={isModalOpen} onClose={handleCloseModal} maxWidth={modalMaxWidth} children={childrenModal} />
        </div>
    );
};

